/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Tabs, Tab } from '@components/molecules'

export interface TabType {
	index: number
	id: string
	label: string
	panel?: React.ReactNode
}

interface PropsType {
	tabList: TabType[]
	tabIndex: number
	onIndexChange: (index: number) => void
}

export const BoxTab = (props: PropsType) => {
	const [value, setValue] = React.useState(props.tabIndex)

	const onIndexChange = (e: React.SyntheticEvent, newIndex: number) => {
		setValue(newIndex)
		props.onIndexChange(newIndex)
	}

	return (
		<Tabs
			css={style}
			value={value}
			indicatorColor="primary"
			textColor="primary"
			onChange={onIndexChange}
			aria-label="disabled tabs example"
		>
			{props.tabList.map(aTab => (
				<Tab key={aTab.id} label={aTab.label} className="tabItem" />
			))}
		</Tabs>
	)
}

const style = css({
	minHeight: '2.5rem',
	marginBottom: '-1rem',

	'.tabItem': {
		minHeight: '2.5rem',
		padding: '0 0.8rem',
		fontWeight: 'bold',
	},

	'@media (max-width:410px)': {
		'.tabItem': {
			minWidth: '1rem',
			fontSize: '14px',
		},
	},

	'@media (max-width:350px)': {
		'.tabItem': {
			fontSize: '13px',
		},
	},

	'@media (max-width:330px)': {
		'.tabItem': {
			fontSize: '12px',
		},
	},

	'@media (max-width:310px)': {
		'.tabItem': {
			fontSize: '11px',
		},
	},

	'@media (max-width:300px)': {
		'.tabItem': {
			fontSize: '10px',
		},
	},
})
